module.exports = __webpack_public_path__ + "img/cn-stu-t.863c7661.png";